import { Component, EventEmitter, input, Output } from '@angular/core';
import { NgClass } from '@angular/common';
import { TooltipDirective } from '@app/directives/tooltip.directive';

@Component({
  selector: 'app-add-remove-buttons',
  imports: [NgClass, TooltipDirective],
  templateUrl: './add-remove-buttons.component.html',
  styleUrl: './add-remove-buttons.component.scss',
})
export class AddRemoveButtonsComponent {
  disabledRemove = input(false);
  disabledAdd = input(false);
  addTooltip = input<string>();
  removeTooltip = input<string>();

  @Output() addItem = new EventEmitter();
  @Output() removeItem = new EventEmitter();

  insertItem() {
    this.addItem.emit();
  }

  deleteItem() {
    this.removeItem.emit();
  }
}
